import { Input, Select } from '@bitcine/cinesend-theme'
import React, { useEffect, useState } from 'react'
import useStore from '../../hooks/use_store'

const ValidatorParams = ({ name, data, fieldId, refreshData }) => {
  const [value, setValue] = useState(() => {
    try {
      return typeof data.parameters.value === 'string' ? JSON.parse(data.parameters.value) : data.parameters.value
    } catch {
      return data.parameters.value
    }
  })

  const { createModel } = useStore()

  useEffect(() => {
    try {
      const parsedValue =
        typeof data.parameters?.value === 'string' ? JSON.parse(data.parameters.value) : data.parameters.value
      setValue(parsedValue)
    } catch {
      setValue(data.parameters?.value)
    }
  }, [data.parameters?.value])

  const saveParamsValue = (val) => {
    const valueToSave = typeof val === 'object' ? JSON.stringify(val) : val

    createModel.mutate(
      {
        endpoint: 'validator-fields',
        data: {
          validator_id: data.id,
          field_id: fieldId,
          severity: data.severity,
          enabled: data.active,
          parameters: {
            options: data.parameters.options,
            value: valueToSave,
          },
        },
      },
      {
        onSuccess: refreshData,
      }
    )
  }

  const isSingleValue = typeof value === 'string' || typeof value === 'number'

  // for list return dropdown
  if (data.parameters.options) {
    return (
      <Select
        id={name}
        options={data.parameters.options}
        value={data.parameters.options.find((item) => item.value == value)}
        onChange={(input) => {
          setValue(input.value)
          saveParamsValue(input.value)
        }}
      />
    )
  }

  return isSingleValue ? (
    <Input name={name} value={value} onChange={(e) => setValue(e.target.value)} onBlur={() => saveParamsValue(value)} />
  ) : (
    <div className='flex flex-wrap gap-2'>
      {Object.entries(value).map(([key, val]) => (
        <Input
          key={key}
          label={key.charAt(0).toUpperCase() + key.slice(1)}
          value={val}
          onChange={(e) => setValue({ ...value, [key]: e.target.value })}
          onBlur={(e) => saveParamsValue({ ...value, [key]: e.target.value })}
        />
      ))}
    </div>
  )
}

export default ValidatorParams
